import { EventEntity } from "../domain/event.entity";

export interface PayloadDTO {
  propId: string;
  propMultId?: string;
  propCountry?: string;
  propCity?: string;
  bookDate?: string;
  bookWeekday?: string;
  bookTime?: string;
  bookTimezone?: string;
  bookGeo?: string;
  bookAdvance?: string;
  checkin?: string;
  checkout?: string;
  stayLength?: string;
  totalPax?: number;
  adultCount?: number;
  kidCount?: number;
  availableRooms?: number;
  globalRestriction?: string;
  noAvailability?: number;
  minPrice?: number;
  avgPrice?: number;
  maxPrice?: number;
  currency?: string;
  lang?: string;
  loyaltyBrand?: string;
  loyaltyUser?: string;
  referrer?: string;
  affiliate?: string;
  origin?: string;
  source?: string;
  medium?: string;
  tag?: string;
  device?: string;
  funnel: string;
  inventoryTicker?: string;
  resMulti?: string;
  resTotal?: number;
  extrasTotal?: number;
  extrasQuantity?: number;
  mandatoryExtras?: number;
  resUnits?: number;
  resPax?: number;
}

export interface EventDTO {
  id: string;
  userId: string;
  sessionId: string;
  payload: PayloadDTO;
  createdAt: Date;
}

export function dtoToEntity(dto: EventDTO[]): EventEntity[] {
  if (!dto?.length) {
    return [];
  }

  return dto.map((eventDTO: EventDTO) => ({
    id: eventDTO.id,
    userId: eventDTO.userId,
    sessionId: eventDTO.sessionId,
    propId: eventDTO.payload.propId,
    propMultId: eventDTO.payload.propMultId,
    propCountry: eventDTO.payload.propCountry,
    propCity: eventDTO.payload.propCity,
    bookDate: eventDTO.payload.bookDate?.toString(),
    bookWeekday: eventDTO.payload.bookWeekday,
    bookTime: eventDTO.payload.bookTime,
    bookTimezone: eventDTO.payload.bookTimezone,
    bookGeo: eventDTO.payload.bookGeo,
    bookAdvance: eventDTO.payload.bookAdvance,
    checkin: eventDTO.payload.checkin,
    checkout: eventDTO.payload.checkout,
    stayLength: eventDTO.payload.stayLength,
    totalPax: eventDTO.payload.totalPax?.toString(),
    adultCount: eventDTO.payload.adultCount?.toString(),
    kidCount: eventDTO.payload.kidCount?.toString(),
    availableRooms: eventDTO.payload.availableRooms?.toString(),
    globalRestriction: eventDTO.payload.globalRestriction,
    noAvailability: eventDTO.payload.noAvailability,
    minPrice: eventDTO.payload.minPrice,
    avgPrice: eventDTO.payload.avgPrice,
    maxPrice: eventDTO.payload.maxPrice,
    currency: eventDTO.payload.currency,
    lang: eventDTO.payload.lang,
    loyaltyBrand: eventDTO.payload.loyaltyBrand,
    loyaltyUser: eventDTO.payload.loyaltyUser,
    referrer: eventDTO.payload.referrer,
    affiliate: eventDTO.payload.affiliate,
    origin: eventDTO.payload.origin,
    source: eventDTO.payload.source,
    medium: eventDTO.payload.medium,
    tag: eventDTO.payload.tag,
    device: eventDTO.payload.device,
    funnel: eventDTO.payload.funnel,
    inventoryTicker: eventDTO.payload.inventoryTicker,
    resMulti: eventDTO.payload.resMulti,
    resTotal: eventDTO.payload.resTotal,
    extrasTotal: eventDTO.payload.extrasTotal,
    extrasQuantity: eventDTO.payload.extrasQuantity?.toString(),
    mandatoryExtras: eventDTO.payload.mandatoryExtras?.toString(),
    resUnits: eventDTO.payload.resUnits?.toString(),
    resPax: eventDTO.payload.resPax?.toString(),
    createdAt: eventDTO.createdAt.toString(),
  }));
}
